import Marquee from "react-fast-marquee";
import { _, Component, Container, Link, React } from "utils";
import { App, Creators, FairStore, SuperfairStore } from "model";
import { CountdownTime } from "components";
import ActiveUsers from "./activeusers";
import "./menu.less";

class Menu extends Component {
  static getStores() {
    return [FairStore, SuperfairStore];
  }

  static calculateState() {
    return {
      fairData: FairStore.getFairData(),
      fairId: FairStore.getFairId(),
      fairLogoUrl: FairStore.getFairLogoUrl(),
      fairs: SuperfairStore.getFairs(),
    };
  }

  toggle() {
    var visible = true;
    Creators.toggleMenu(visible);
  }

  toggleInfo() {
    Creators.setOverlayVisible("info", true);
  }

  onLogoError() {
    Creators.setFairLogoUrl(App.resourceUrl("logo.png"));
  }

  render() {
    var briefcaseUrl = App.resourceUrl("briefcase.svg");
    var clipboardUrl = App.resourceUrl("clipboard.svg");
    var calendarUrl = App.resourceUrl("calendar.svg");
    var questionMarkUrl = App.resourceUrl("questionmark.svg");
    var hackathonUrl = App.resourceUrl("hackathon-menu-icon.svg");

    var { fairs, fairId, fairLogoUrl, fairData } = this.state;

    let now = new Date();
    let end = new Date(fairData.endsAt);
    let fairEnded = now > end;

    fairLogoUrl = fairLogoUrl ? fairLogoUrl : App.resourceUrl("logo.png");

    let chest = fairData.displayChest ? (
      <span className="info chest-icon">
        <img src="/images/chest.png" onClick={this.toggleInfo}></img>
        <div id="bubble" onClick={this.toggleInfo}>
          {_("Get prize")}
        </div>
      </span>
    ) : null;

    let hackathonMenuItem = fairData.hackathonLink ? (
      <li className="nav-item">
        <a className="nav-link hackathon" href={fairData.hackathonLink}>
          <img src={hackathonUrl} alt={_("Hackathon")} />
          {_("Hackathon")}
        </a>
      </li>
    ) : null;
    return (
      <div className="menu">
        <nav className="navbar navbar-light navbar-expand-xl bg-light">
          <span className="navbar-column">
            <Link to="/" className="navbar-brand">
              <img
                src={fairLogoUrl}
                alt={fairData.name}
                onError={this.onLogoError}
              />
            </Link>
            {chest}
          </span>
          <CountdownTime />
          {fairs.length > 1 && (
            <FairGroup data={fairs} fairId={this.state.fairId} />
          )}
          <div className="navbar-column navbar-column-right">
            <button
              className="navbar-toggler"
              type="button"
              onClick={this.toggle}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarNav"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link nav-link-jobs" to="/jobs">
                    <img alt={_("All jobs")} src={briefcaseUrl} />
                    <span>{_("All jobs")}</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link nav-link-exhibitors" to="/index">
                    <img alt={_("All exhibitors")} src={clipboardUrl} />
                    <span>{_("All exhibitors")}</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link nav-link-exhibitors" to="/events">
                    <img alt={_("Events")} src={calendarUrl} />
                    <span>{_("Events")}</span>
                  </Link>
                </li>
                {hackathonMenuItem}
              </ul>

              {fairs.length > 1 && (
                <ul className="navbar-nav bordered">
                  {fairs.map((item) => {
                    return item.id !== fairId ? (
                        <li key={item.id} className="nav-item">
                          <a
                              className="nav-link"
                              href={item.link}
                              target="_blank"
                          >
                            <img alt={_(item.description)} src={item.iconUrl}/>
                            <span className="title">
                            <span>{_(item.description)}</span>
                          </span>
                          </a>
                        </li>
                    ) : null;
                  })}
                </ul>
              )}
            </div>
            <ActiveUsers />
          </div>
        </nav>
        {false && fairEnded ? (
          <div className="site-alert">{_("Fair closed")}</div>
        ) : null}

        {fairData.message && (
          <div className="site-alert small">
            <Marquee speed={100} gradient={false} pauseOnHover={true}>
              <div dangerouslySetInnerHTML={{ __html: fairData.message }} />
            </Marquee>
          </div>
        )}
      </div>
    );
  }
}

function FairGroup({ data, fairId }) {
  var items = data.map((item) => {
    return item.id !== fairId ? (
        <div
            key={item.id}
            className="header-icon"
        >
          <a href={item.link} target="_blank">
            <img alt="" src={item.iconUrl}/>
          </a>
        </div>
    ) : null;
  }).filter(Boolean);

  return <div className="header-icon-menu">{items}</div>;
}

export default Container.create(Menu);



// WEBPACK FOOTER //
// ./src/modules/components/menu.js